import './SvgIcon.scss';

interface ISvgIcon {
  icon: string;
  className?: string;
}
export const SvgIcon = (props: ISvgIcon) => {
  const {icon, className} = props;
  return (
    <div className={`svgIcon ${className ?? ''}`}>
      <svg>
        <use xlinkHref={`#${icon}`} />
      </svg>
    </div>
  );
};
